import axios from "axios";
import { useEffect } from "react"
import { useDispatch} from "react-redux";
import { setUser } from '../store/userslice';

const useAutoLogin = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        async function getautologin() {

            try {

                let response = await axios.get('http://172.22.64.245:8800/refresh', {
                    withCredentials : true
                });
                if (response.status === 200) {

                    const user = {
                        username: response.data.newuser.username,
                        _id: response.data.newuser._id,
                        photo: response.data.newuser.photo,
                        auth: response.data.newuser.auth,
                        name: response.data.newuser.name,
                        followings : response.data.follows.followings,
                        followers : response.data.follows.followers
                    }
                    dispatch(setUser(user));
                }
            } catch (error) {
                return error;
            }
        }
        getautologin();
    }, [])
}

export default useAutoLogin;